module.exports = __webpack_public_path__ + "img/icon_kyvipkcslt.490ccd71.png";